module.exports = __webpack_public_path__ + "img/christmas-gift.c4d13cad.png";